import { render, staticRenderFns } from "./PerbaruiProfilPenelitiKeamanan.vue?vue&type=template&id=1c15f2c2&scoped=true&"
import script from "./PerbaruiProfilPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./PerbaruiProfilPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c15f2c2",
  null
  
)

export default component.exports